import { Controller } from "@hotwired/stimulus";

let sequence = 0;

export default class extends Controller {
  static targets = ["mainToggle", "contentArea"];

  connect() {
    this.linkToggleToContent();
    this.updateContentState();
    // Notify about initial state
    this.notifyStateChange();
  }

  toggle(event) {
    try {
      const isChecked = this.mainToggleTarget.checked;
      this.updateContentState(isChecked);
      // Notify about state change
      this.notifyStateChange();
    } catch (error) {
      console.error("Error in toggle:", error);
    }
  }

  // Names the revealed region on the toggle, so the toggle announces that it
  // owns content and whether that content is showing. Ids are generated here
  // rather than required of every caller.
  linkToggleToContent() {
    const ids = this.contentAreaTargets.map((content) => {
      if (!content.id) content.id = `checkbox-disclosure-${++sequence}`;
      return content.id;
    });

    this.mainToggleTarget.setAttribute("aria-controls", ids.join(" "));
  }

  updateContentState(isChecked = null) {
    // If isChecked is not provided, use the current checkbox state
    const checked =
      isChecked !== null ? isChecked : this.mainToggleTarget.checked;

    this.mainToggleTarget.setAttribute("aria-expanded", checked);

    this.contentAreaTargets.forEach((content) => {
      // Toggle visibility
      content.classList.toggle("hidden", !checked);

      // Only the outermost fieldsets. A disabled fieldset already bars every
      // descendant control from submitting, and reaching deeper would clobber
      // the disabled state that a nested controller (fieldset-selector) owns.
      const fieldsets = content.querySelectorAll(":scope > fieldset");
      fieldsets.forEach((fieldset) => {
        if (!checked) {
          // Add disabled attribute to fieldset
          fieldset.setAttribute("disabled", "disabled");
          // Add visual indication that it's disabled with reduced opacity
          fieldset.classList.add("opacity-50");
        } else {
          // Remove disabled attribute from fieldset
          fieldset.removeAttribute("disabled");
          // Remove visual indication
          fieldset.classList.remove("opacity-50");
        }
      });
    });
  }

  // New method to notify about state changes
  notifyStateChange() {
    const isChecked = this.mainToggleTarget.checked;
    const event = new CustomEvent("checkbox-disclosure:changed", {
      bubbles: true,
      detail: { checked: isChecked },
    });
    this.element.dispatchEvent(event);
  }
}
